import EmptyNotes from './svg/empty/notes-empty.svg'

export default EmptyNotes
